
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.0023 4L14.6017 9.26604L20.4145 10.1157L16.2084 14.2124L17.201 20L12.0023 17.266L6.80355 20L7.79619 14.2124L3.59009 10.1157L9.40292 9.26604L12.0023 4Z","fill":"#FFC72C"}}),_c('path',{attrs:{"d":"M12.0023 4L14.6017 9.26604L20.4145 10.1157L16.2084 14.2124L17.201 20L12.0023 17.266L12 16L12.0023 14.2124V12L12 9L12.0023 4Z","fill":"#E9E9EA"}})])
          )
        }
      }
    